import React from 'react';
import PropTypes from 'prop-types';

const FinishedLoginElement = ({ data }) => (
    <div className="form-group selector_FINISHED_LOGIN_ELEMENT">
        <div className="alert alert-warning" role="alert">
            {data.name} <span className="icon-check"></span>
        </div>
    </div>
);

const FinishedLoginsList = ({ finishedLogins }) => {
    if (!finishedLogins || finishedLogins.list.length === 0) return null;

    return (
        <div className="form-group selector_FINISHED_LOGINS">
            {finishedLogins.list.map((element, i) => (
                <FinishedLoginElement data={element} key={i} />
            ))}
        </div>
    );
};

FinishedLoginsList.propTypes = {
    finishedLogins: PropTypes.shape({
        list: PropTypes.array.isRequired
    }).isRequired
};

export default FinishedLoginsList;